/**
    @title: Lazy Loading
    @observers: {
        - image: Images with srcset data attribute
        - iframe: Iframes with the iframe src data attribute
        - background: backgrounds with the bg data attribute
    }
**/

const leaderMenuWrapper = document.querySelector("[data-leader-container]");
const leaderMenu 		= document.querySelector("[data-leader-menu]");
//const minWidth = mainMenu ? parseInt(mainMenu.dataset.breakpoint) : 0;

// Set these variables before the functions so they can be used in multiple places
let leadershipVideoObserver;

/**
    @title: Lazy
    @description: Uses Intersection Observer to check whether or not the item is within the viewport.
		If it is then we need to change the markup so the element is loaded.
**/
function initLeadership() {
	const leadershipVideo = Array.from(document.querySelectorAll("[data-leadership-video]"));

	if ("IntersectionObserver" in window) {
		// Image Observer for loading Images
			leadershipVideoObserver = new IntersectionObserver(function (videos) {
				// Loop through all applicable videos on the page
				videos.forEach(function (video) {
					// Returns a boolean value if the video intersects with the intersection observer's root
					if (video.isIntersecting) {
						// Get the target video
						let target = video.target;

						//target.setAttribute("autoplay", "");
						target.muted = true;
						target.play();

						target.onload = () => {
							leadershipVideoObserver.unobserve(target);
						};
					}
				});
			});

		// Loop through all the images and observe them
		leadershipVideo.forEach(function (videos) {
			leadershipVideoObserver.observe(videos);
		});

	}


	// Leadership bio slider
	const leaderTrigger = document.querySelectorAll("[data-leader-open]");
	const leaderClose   = document.querySelectorAll("[data-leader-close]");

	if (leaderMenu) {
		// Check the trigger exists
		if (leaderTrigger) {
			
			leaderTrigger.forEach(function (open) {
				open.addEventListener("click", menuButtonHandler.bind(open, "open"));
				console.log('event added: open');
			});
		}

		// Check the close button exists
		if (leaderClose) {
			leaderClose.forEach(function (close) {
				close.addEventListener("click", menuButtonHandler.bind(close, "close"));
				console.log('event added: close');
			});
		}
	}


	function menuButtonHandler(action) {
		switch (action) {
			case "open":
				leaderMenuWrapper.setAttribute("data-leader-container", "open");

				document.body.setAttribute("data-leader-open", "");
				leaderMenu.setAttribute("data-leader", "open");
				leaderMenu.setAttribute("aria-hidden", "false");

				var biogName  = document.querySelector("[data-biog-name]");
				var biogTitle = document.querySelector("[data-biog-title]");
				var biogText  = document.querySelector("[data-biog-text]");

				// Get the index
				var index = this.getAttribute("data-index");

				// Find the index in the leaderData json object
				var leaderDataItem = leaderData[index];

				// Set the data
				biogName.innerHTML  = leaderDataItem.name;
				biogTitle.innerHTML = leaderDataItem.title;
				biogText.innerHTML  = leaderDataItem.biog;

				break;
			case "close":
				leaderMenuWrapper.setAttribute("data-leader-container", "closed");

				document.body.removeAttribute("data-leader-open");
				leaderMenu.setAttribute("data-leader", "");
				leaderMenu.setAttribute("aria-hidden", "true");
				break;
			default:
				return;
		}
	}



}

export { initLeadership };
